import { Link } from "react-router-dom";
import {
  IoCreateOutline,
  IoChevronForwardOutline,
  IoTrashOutline,
} from "react-icons/io5";

const TYPE_COLORS = {
  hero: "bg-violet-100 text-violet-700",
  cards: "bg-sky-100 text-sky-700",
  list: "bg-emerald-100 text-emerald-700",
  process: "bg-amber-100 text-amber-700",
  pricing: "bg-teal-100 text-teal-700",
  articles: "bg-fuchsia-100 text-fuchsia-700",
  projects: "bg-indigo-100 text-indigo-700",
  positions: "bg-orange-100 text-orange-700",
};

function typeBadgeClass(type) {
  return TYPE_COLORS[(type || "").toLowerCase()] || "bg-slate-100 text-slate-600";
}

export default function SectionList({
  sections,
  onEdit,
  onDelete,
  onTogglePublish,
}) {
  if (!sections.length) return null;

  return (
    <div className="space-y-4">
      {sections.map((section, index) => (
        <article
          key={section.id}
          className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition hover:border-slate-300 hover:shadow-md"
        >
          <div className="flex flex-col gap-4 p-5 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex min-w-0 items-start gap-4">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-slate-900 text-sm font-semibold text-white">
                {String(index + 1).padStart(2, "0")}
              </div>
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="text-base font-semibold text-slate-900">
                    {section.name}
                  </h3>
                  <span
                    className={`rounded-full px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${typeBadgeClass(section.sectionType)}`}
                  >
                    {section.sectionType}
                  </span>
                </div>
                <p className="mt-1 font-mono text-xs text-slate-500">
                  {section.key}
                </p>
                <p className="mt-2 text-xs text-slate-400">
                  Display order: {section.sortOrder}
                </p>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-2 lg:justify-end">
              <button
                type="button"
                onClick={() => onTogglePublish(section)}
                className={`rounded-xl px-3 py-2 text-xs font-semibold uppercase tracking-wide ${
                  section.isPublished
                    ? "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200"
                    : "bg-amber-50 text-amber-700 ring-1 ring-amber-200"
                }`}
              >
                {section.isPublished ? "Published" : "Draft"}
              </button>
              <Link
                to={`/cmsadmin/dashboard/pages/${section.cmsPageId}/sections/${section.id}`}
                className="inline-flex items-center gap-2 rounded-xl bg-slate-900 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-slate-800"
              >
                Edit content
                <IoChevronForwardOutline className="h-4 w-4" />
              </Link>
              <button
                type="button"
                onClick={() => onEdit(section)}
                className="rounded-xl border border-slate-200 p-2.5 text-slate-600 transition hover:bg-slate-50"
                aria-label={`Edit settings for ${section.name}`}
                title="Section settings"
              >
                <IoCreateOutline className="h-4 w-4" />
              </button>
              <button
                type="button"
                onClick={() => onDelete(section)}
                className="rounded-xl border border-red-200 p-2.5 text-red-600 transition hover:bg-red-50"
                aria-label={`Delete ${section.name}`}
                title="Delete section"
              >
                <IoTrashOutline className="h-4 w-4" />
              </button>
            </div>
          </div>
        </article>
      ))}
    </div>
  );
}
